module.exports = new __parcel__URL__("card_hornet.49eb0894.png").toString();